/** The person's connections, as Settings and the banner both read them. */
import { useQuery } from "@tanstack/react-query";

import { api } from "../api/client";
import { ok } from "../api/query";

export const CONNECTIONS = ["connections", "status"] as const;

export function useConnections() {
  return useQuery({
    queryKey: CONNECTIONS,
    queryFn: () => ok(api.GET("/api/integrations/status")),
  });
}
